import React, {useEffect, useState} from 'react';
import '../App.css';
import './ImageHeader.css';
import {Fade} from 'react-awesome-reveal';

function ImageHeader(props) {
  var style;
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  /* Capture-phase wheel listener so trackpad scroll works on Restaurant/Catering (no passive blocking) */
  useEffect(() => {
    const handleWheel = (e) => {
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      window.scrollBy(0, e.deltaY);
      e.preventDefault();
    };
    document.addEventListener('wheel', handleWheel, { passive: false, capture: true });
    return () => document.removeEventListener('wheel', handleWheel, { capture: true });
  }, []);

  if (width <= 580) {
    style = {
      backgroundImage: `url(${props.imgPathNarrow})`
    };
  } else {
    style = {
      backgroundImage: `url(${props.imgPath})`
    };
  }

  return (
    <div className='header-container'>
      <div className='img-container' style={style}></div>
      {props.isHero &&
        <Fade direction={'up'} duration={2000} distance={"150px"} delay={500} triggerOnce={true}>
          <div className="header-txt-container">
            <h1 className={'header-txt'}>{props.headerText}</h1>
            {props.subtitle && <p className="header-subtitle">{props.subtitle}</p>}
          </div>
        </Fade>
      }
    </div>
  );
}

export default ImageHeader;
